var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asset-ficha" },
    [
      _c(
        "v-row",
        { staticClass: "ma-0" },
        [
          _vm._l(_vm.groups, function(group) {
            return _c(
              "v-col",
              {
                key: group.key,
                staticClass: "py-2",
                attrs: { cols: "12", md: "4" }
              },
              [
                _c(
                  "div",
                  { staticClass: "asset-ficha__group" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "asset-ficha__group-title az-ds-card-title"
                      },
                      [_vm._v(" " + _vm._s(group.title) + " ")]
                    ),
                    _vm._l(group.fields, function(field) {
                      return _c(
                        "div",
                        { key: field.key, staticClass: "asset-ficha__row" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "asset-ficha__label az-text-secondary az-size-14"
                            },
                            [
                              _vm._v(" " + _vm._s(field.label) + " "),
                              field.info
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "icon-svg",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          name:
                                                            "mdi-information-outline",
                                                          size: 16,
                                                          color: "secondary"
                                                        }
                                                      },
                                                      "icon-svg",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "asset-ficha__tooltip-content"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(field.info))
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          field.precisaDica
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    bottom: "",
                                    "open-delay": "400",
                                    "max-width": "320"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "asset-ficha__value asset-ficha__value--truncado az-text-primary az-size-14"
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(field.value) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [_c("span", [_vm._v(_vm._s(field.value))])]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "asset-ficha__value az-text-primary az-size-14"
                                },
                                [_vm._v(" " + _vm._s(field.value) + " ")]
                              )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ]
            )
          }),
          _vm.hasTags || _vm.hasComentario
            ? _c("v-col", { staticClass: "py-2", attrs: { cols: "12" } }, [
                _c("div", { staticClass: "asset-ficha__group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "asset-ficha__group-title az-ds-card-title"
                    },
                    [_vm._v(" Tags e comentários ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "asset-ficha__bloco" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "asset-ficha__label az-text-secondary az-size-14"
                        },
                        [_vm._v(" Tags ")]
                      ),
                      _vm.hasTags
                        ? _c("TagField", {
                            attrs: { value: _vm.asset.tags, readonly: "" }
                          })
                        : _c(
                            "span",
                            {
                              staticClass:
                                "asset-ficha__value az-text-primary az-size-14"
                            },
                            [_vm._v(" - ")]
                          )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "asset-ficha__bloco" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "asset-ficha__label az-text-secondary az-size-14"
                      },
                      [_vm._v(" Comentário ")]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "asset-ficha__comentario az-text-primary az-size-14"
                      },
                      [_vm._v(" " + _vm._s(_vm.asset.comentario || "-") + " ")]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }